<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" :initialFocus="activeElement" @close="closeModal">
      <div class="fixed inset-0 z-30 overflow-y-auto">
        <div class="min-h-screen text-center flex">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-10"
            leave="duration-200 ease-in"
            leave-from="opacity-10"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
          </TransitionChild>

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-50"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-50"
          >
            <div
              class="inline-block md:w-1/3 mx-auto my-20 mx-3 h-full max-w-screen-md m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded"
            >
              <div class="flex flex-row">
                <div class="flex-1"></div>
                <div class="flex-4 pr-2 pt-2 cursor-pointer" @click="closeModal">
                  <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                </div>
              </div>

              <div class="pb-5 px-5 md:px-8">
                <h2 class="text-xl text-brand-black pb-3">Delete Form</h2>

                <p class="py-2">Are you sure you want to delete this form?</p>

                <div class="flex flex-row items-center justify-center pt-5">
                  <div class="mr-3">
                    <SecondaryButton @click="closeModal">Cancel</SecondaryButton>
                  </div>
                  <div class="flex items-center w-1/3">
                    <PrimaryButton
                      :classes="'bg-brand-red border-brand-red hover:bg-brand-red'"
                      :disabled="isApplicationTemplateLoading"
                      @click="deleteForm"
                      >Delete</PrimaryButton
                    >
                  </div>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import { mapGetters } from "vuex"
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

import { XIcon } from "@heroicons/vue/outline"

import { APPLICATION_TEMPLATE_DELETE, APPLICATION_TEMPLATE_GET_LIST } from "@/store/types"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close"],
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  computed: {
    ...mapGetters(["isApplicationTemplateLoading", "getCurrentApplicationTemplate"]),
    activeElement() {
      return document.activeElement
    }
  },
  data() {
    return {}
  },
  methods: {
    closeModal() {
      this.$emit("close")
    },
    async deleteForm() {
      await this.$store.dispatch(APPLICATION_TEMPLATE_DELETE, {
        slug: this.getCurrentApplicationTemplate.slug
      })
      await this.$store.dispatch(APPLICATION_TEMPLATE_GET_LIST, { page: 1 })
      this.closeModal()
      this.$router.push({ name: "dashboard_forms" })
    }
  }
}
</script>
<style scoped></style>
